import React from 'react';
import { VStack } from 'native-base';
import { PrimaryButton, TertiaryButton } from '@breakroom-nx/ui';

import { User } from '@breakroom-nx/classes';
import { FriendState } from '@breakroom-nx/helpers';

// Redux
import {
  useAppDispatch,
  useGetFriendStateOfUserWithUIDQuery,
  useUpdateFriendStateMutation,
} from '@breakroom-nx/redux';

// Firebase
import { auth } from '@breakroom-nx/apis';

// Assets & Icons
import { theme } from '@breakroom-nx/assets';
import {
  ClockIcon,
  UserAddIcon,
  UserRemoveIcon,
} from 'react-native-heroicons/solid';
import { QueryStatus } from '@reduxjs/toolkit/dist/query';
export interface PublicProfieFriendActionsProps {
  user: User;
}

export function PublicProfieFriendActions({
  user,
}: PublicProfieFriendActionsProps) {
  const dispatch = useAppDispatch();

  const { data: friendStatus, isLoading } = useGetFriendStateOfUserWithUIDQuery(
    user.uid
  );
  const [updateFriendState, updatingFriendState] =
    useUpdateFriendStateMutation();

  const updateFriendStatus = async (decline = false) => {
    if (friendStatus && auth.currentUser) {
      await updateFriendState({
        friendID: user.uid,
        newFriendState: friendStatus,
        decline: decline,
      })
        .then(() => {
          // console.log(`Friend State Updated!`);
        })
        .catch((err) => {
          // console.log(`An Error Occured With Friend Status`);
        });

      // await modifyFriendState(user.uid, friendStatus, decline).then(
      //   (newFriendState) => {
      //     setModifyingFriendState(false);
      //     if (newFriendState !== friendStatus) {
      //       //! FIX Automatically Update View on Mutation
      //       // setFriendStatus(newFriendState);
      //     } else {
      //       // Throw Error
      //       console.log(`An Error Occured With Friend Status`);
      //     }
      //   }
      // );
    }
  };

  function getFriendIcon() {
    switch (friendStatus) {
      case FriendState.Friend:
        return <UserRemoveIcon size={17} />;
      case FriendState.RequestSent:
        return <ClockIcon size={17} color={theme.colors.surface[600]} />;
      case FriendState.InvitePendingClientApproval:
      case FriendState.NotFriend:
      default:
        return <UserAddIcon size={17} />;
    }
  }

  function getFriendButtonColor() {
    switch (friendStatus) {
      case FriendState.Friend:
      case FriendState.RequestSent:
        return theme.colors.surface[700];
      case FriendState.InvitePendingClientApproval:
      case FriendState.NotFriend:
      default:
        return theme.colors.surface[400];
    }
  }

  function getFriendButtonBackground() {
    switch (friendStatus) {
      case FriendState.Friend:
      case FriendState.RequestSent:
        return theme.colors.surface[300];
      case FriendState.InvitePendingClientApproval:
      case FriendState.NotFriend:
      default:
        return theme.colors.primary[400];
    }
  }

  return (
    <VStack justifyContent={'center'} alignItems={'center'} space={4}>
      <PrimaryButton
        isLoading={updatingFriendState.status === QueryStatus.pending}
        disabled={
          isLoading || updatingFriendState.status === QueryStatus.pending
        }
        color={getFriendButtonColor()}
        bg={getFriendButtonBackground()}
        text={friendStatus ? friendStatus : FriendState.Friend}
        onPress={() => updateFriendStatus()}
        startIcon={getFriendIcon()}
      />

      {friendStatus === FriendState.InvitePendingClientApproval && (
        <TertiaryButton
          isLoading={updatingFriendState.status === QueryStatus.pending}
          disabled={
            isLoading || updatingFriendState.status === QueryStatus.pending
          }
          color={theme.colors.red[200]}
          text={'Decline Friend Request'}
          onPress={() => updateFriendStatus(true)}
        />
      )}
    </VStack>
  );
}

export default React.memo(PublicProfieFriendActions);
